import { getSettingsScheduleApi as generatedGetSettingsScheduleApi } from '../generated/settingsSchedule/getSettingsSchedule';

const getSettingsScheduleApi = generatedGetSettingsScheduleApi.enhanceEndpoints({
  endpoints: {
    getSettingsSchedule: {
      providesTags: ['SettingsSchedule'],
    },
  },
});

export const { useGetSettingsScheduleQuery } = getSettingsScheduleApi;
